import FileModel from "./FileModel";
import FileTreeNode from "./FileTreeNode";
import FileExplorerModelEvent from "./FileExplorerModelEvent";

export default class FileExplorerModel {
    /**
     * @constructor
     * @param {soma.EventDispatcher} dispatcher 
     * @param {FileModel} fileModel 
     */
    constructor(dispatcher, fileModel) {
        this._dispatcher = dispatcher;
        this._fileModel = fileModel;

        /** @type {FileTreeNode} */
        this._currentFileTreeNode = null;
    }

    get currentFileTreeNode() {
        return this._currentFileTreeNode || this._fileModel.fileTree.root;
    }

    set currentFileTreeNode(value) {
        if (this._currentFileTreeNode === value) {
            return;
        }

        this._currentFileTreeNode = value;
        this._dispatcher.dispatch(FileExplorerModelEvent.TREE_CHANGED);
    }

    getCurrentPath() {
        let path = [];
        let node = this.currentFileTreeNode;
        while (node.parent) {
            path.splice(0, 0, node.data.getName()); // add it at the begin of the array as we're walking up the nodes
            node = node.parent;
        }

        return '/' + path.join('/');
    }
}